var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"ci-action-icon-container ci-action-icon-wrapper",class:_vm.cssClass,attrs:{"data-method":_vm.actionMethod,"title":_vm.tooltipText,"href":_vm.link,"data-container":"body"}},[_c('icon',{attrs:{"name":_vm.actionIcon}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bdefc0a","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/action_component.vue
// module id = null
// module chunks = 